import PropTypes from 'prop-types';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { AuthContext } from 'src/auth/context/jwt';
import { paths } from 'src/routes/paths';
import customAxios from 'src/utils/customAxios';
import { useAuthContext } from '../hooks';

export default function OnboardingGuard({ children }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const returnTo = searchParams.get('returnTo') || paths.dashboard.root;
  const loginPage = paths.auth.jwt.login;
  const { authenticated } = useAuthContext();
  const { user } = useContext(AuthContext) || {};
  const { onBoarding } = user || {};
  const [userData, setUserData] = useState(null);

  const getUser = async () => {
    try {
      const {
        data: { data },
      } = await customAxios.get(`https://abibiman-api.onrender.com/users/${user?.userID}`);

      setUserData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userID]);

  const check = useCallback(() => {
    if (userData?.onBoarding === 'pending') {
      router.replace(paths.onboarding);
    }
  }, [userData, router]);

  useEffect(() => {
    if (userData) {
      check();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return <>{children}</>;
}

OnboardingGuard.propTypes = {
  children: PropTypes.node,
};
